// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__YA0h9","unread":"Notification_unread__Ix3N6","image":"Notification_image__x-13J"};